/*
* @Description: ""
* @Author: YOYO 792611446@qq.com
 * @LastEditors: ChangWenBo (649160016@qq.com)
* @Date:   2019-04-18 17:25:40
 * @LastEditTime: 2021-04-02 11:17:40
*/
import request from '@/utils/request'
// import { getServiceCode } from '@/cont.js'
// const areaCode = getServiceCode(process.env.VUE_APP_REGIONAL)
// 客户管理列表分页查询
const customerslistUrl = '/rest/base/customers/page'
// 新增客户管理
const customerssaveUrl = '/rest/base/customers/save'
// 根据字典类型查询字典列表
const listDictByTypeUrl = '/rest/base/dict/listDictByType'

/**
 * @description: 客户管理列表分页查询
 * @param        {object} params 请求接口参数：pageNo='页码'，pageSize='每页条数'
 * @return       {object} res
 */
export async function getCustomerslist (params) {
  return request.get(customerslistUrl, {
    ...params,
  })
}

/**
 * @description: 删除客户信息
 * @param        {object} params id='客户主键'
 * @return       {object} res
 */
export async function deleteCustomer (params) {
  return request.post(`/rest/base/customers/${params}/del`, {
    ...params,
  })
}

/**
 * @description: 保存客户信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function saveCustomer (params) {
  return request.post(customerssaveUrl, {
    ...params,
  }, {}, 2)
}
/**
 * @description: 客户管理列表分页查询
 * @param        {object} params 请求接口参数：type='字典类型'
 * @return       {object} res
 */
export async function getlistDictByType (params) {
  return request.get(listDictByTypeUrl, {
    ...params,
  })
}
/**
 * @description: 客户管理详情
 * @param        {object} params id='客户主键'
 * @return       {object} res
 */
export async function customerDetail (params) {
  return request.get(`/rest/base/customers/${params}/detail`, {
    ...params,
  })
}
/**
 * @description: 更新客户信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function updateCustomer (params) {
  console.log(params)
  return request.post(`/rest/base/customers/${params.id}/update`, {
    ...params,
  }, {}, 2)
}
